// JavaScript Document
//Login.js
import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
//import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
//import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function Login(props) {
  //const [open, setOpen] = React.useState(false);
  const {loginOpen, setLoginOpen, handleSend, getUserSession} = props;
  const [values, setValues] = React.useState({
	  username: '',
	  password: '',
	  showPassword: false
  });
  const handleChange = (prop) => (event) => {
	  setValues({...values, [prop]:event.target.value});
  }
  const handleClickShowPassword = () => {
	  setValues({ ...values, showPassword: !values.showPassword});
  }
  const handleMouseDownPassword = (event) => {
	  event.preventDefault();
  }
  //const handleClickOpen = () => {
  //  setOpen(true);
  //};

  const handleClose = () => {
    setLoginOpen(false);
  };
  const handleLogin = (e) => {
	  if(e){
		  e.preventDefault();
	  }
	  handleSend({
		  vso: 'login',
		  username: values.username,
		  password: values.password
	  }, (data) => {
		  //setLoaded(false);
		  getUserSession();
	  });
	  handleClose();
  }
	

  return (
    <div>
      <Dialog open={loginOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
	  	<form onSubmit={handleLogin}>
        <DialogTitle id="form-dialog-title">Please log in to continue</DialogTitle>
        <DialogContent>
          <TextField
	        required
            autoFocus
            margin="dense"
            id="username"
            label="Username or Email Address"
            type="text"
	  		onChange={handleChange('username')}
			value={values.username}
            fullWidth
          />
	  	  <FormControl fullWidth required>
			<InputLabel htmlFor="password">Password</InputLabel>
			<Input
			  id="password"
			  type={values.showPassword ? 'text' : 'password'}
			  value={values.password}
			  onChange={handleChange('password')}
			  endAdornment={
				<InputAdornment position="end">
				  <IconButton
				    aria-label="Toggle password visibility"
					onClick={handleClickShowPassword}
					onMouseDown={handleMouseDownPassword}
				  >
					{values.showPassword ? <Visibility /> : <VisibilityOff />}
				  </IconButton>
				</InputAdornment>
			  }
			/>
		  </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary">
            Log in
          </Button>
        </DialogActions>
		 </form>
      </Dialog>
    </div>
  );
}
